export enum CalloutResponseMode {
  Single = 'single',
  SingleEditable = 'single-editable',
  Multiple = 'multiple',
}
